import { Grid } from "@material-ui/core";
import React from "react";
import { DataCard, DataCardDefaultItem } from "@ofqual/portal-components/components/DataCard/DataCard";
import { WorkHistoryModel } from "../../domain/WorkHistoryModel";

export const WorkHistory: React.FC<{
  roles: WorkHistoryModel[]
}> = ({ roles }) => {

  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const displayRoles = (role: WorkHistoryModel) => {
    const items: DataCardDefaultItem[] = [
      {
        itemType: "DEFAULT",
        key: "Name of employer",
        value: role.employerName
      },
      {
        itemType: "DEFAULT",
        key: "Job title",
        value: role.jobTitle,
      },
      {
        itemType: "DEFAULT",
        key: "Start date",
        value: months[role.startMonth - 1].concat(" ", role.startYear.toString())
      },
      {
        itemType: "DEFAULT",
        key: "Are you still working in this role?",
        value: role.isinRole ? "Yes" : "No",
      }
    ]

    if (!role.isinRole) {
      items.push(
        {
          itemType: "DEFAULT",
          key: "End date",
          value: months[role.endMonth! - 1].concat(" ", role.endYear!.toString()),
        }
      )
    }

    return items
  }

  return (
    <>
      <div style={{ overflowWrap: 'break-word' }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {roles.map((role, index) => {
              return (
                <React.Fragment key={index}>
                  {index > 0 ? <br /> : <></>}
                  <DataCard
                    showHeading={false}
                    heading={null}
                    items={displayRoles(role)}
                    hasAction={false}
                    actionDescription={null}
                    actionButtonText={null}
                    actionFunction={null}
                    headingComponent={"h1"}
                  />
                </React.Fragment>
              );
            })
            }
          </Grid>
        </Grid>
      </div>
    </>
  );
};
